import { FunctionComponent, SVGProps } from 'react';
import {
  FileExcelSolid,
  FilePdfSolid,
  FilePowerPointSolid,
  FileWordSolid,
  FileVideoSolid,
  FileImageSolid,
  File,
} from '@assets/svgs';
import {
  EXCEL_TYPES,
  IMAGE_TYPES,
  PDF_TYPES,
  POWERPOINT_TYPES,
  VIDEO_TYPES,
  WORD_TYPES,
} from '@components/drawerItem/DrawerItem.constants';

interface IAttachment {
  key: string;
  value: string;
  acceptedTypes: string[];
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}

const fileAttachments = [
  {
    key: 'excel',
    value: 'Excel Document',
    acceptedTypes: EXCEL_TYPES,
    Icon: FileExcelSolid,
  },
  {
    key: 'powerPoint',
    value: 'PowerPoint Document',
    acceptedTypes: POWERPOINT_TYPES,
    Icon: FilePowerPointSolid,
  },
  {
    key: 'pdf',
    value: 'PDF File',
    acceptedTypes: PDF_TYPES,
    Icon: FilePdfSolid,
  },
  {
    key: 'word',
    value: 'Word Document',
    acceptedTypes: WORD_TYPES,
    Icon: FileWordSolid,
  },
  {
    key: 'video',
    value: 'Video File',
    acceptedTypes: VIDEO_TYPES,
    Icon: FileVideoSolid,
  },
  {
    key: 'image',
    value: 'Image File',
    acceptedTypes: IMAGE_TYPES,
    Icon: FileImageSolid,
  },
];

export function getAttachment(fileType: string): IAttachment {
  let attachmentRes = fileAttachments.find((file) => file.acceptedTypes.includes(fileType));
  if (attachmentRes === undefined) {
    attachmentRes = {
      key: 'file',
      value: 'File',
      acceptedTypes: [],
      Icon: File,
    };
  }
  return attachmentRes;
}
